import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExportControlService {
  private exporting: Subject<boolean> = new BehaviorSubject<boolean>(false);
  private exporting$: Observable<boolean> = this.exporting.asObservable();

  constructor() {}

  setExporting(value: boolean): void {
    this.exporting.next(value);
  }

  getExporting(): Observable<boolean> {
    return this.exporting$;
  }
}
